import { useEffect, useState } from "react"
import { ENDPOINTS } from "../../../constants/endpoints"
import useFetch from "../../../hooks/useFetch"

function useFetchThemes(userId,type) {
    const {fetch,loading} = useFetch()

    const [themes,setThemes] = useState([])
    useEffect(() => {
        _fetchData()
    }, [])
    
    function _fetchData() {
        fetch({endpoint: `${ENDPOINTS.COUNCILOR.MESSAGES}?id=${userId}&type=${type}`,method:'get'})
        .then(res => {
            setThemes(res.data)
        })
    }

    function getThemes() {
        return themes
    }

    function refetchData(page) {
        _fetchData(page)
    }

    return {
        getThemes,
        refetchData,
        loading
    }
}
export default useFetchThemes